lmApp
  .directive('lmVideoUpload', ['$timeout', '$window', '$rootScope', 'AssetService', 'ImportService',
    function ($timeout, $window, $rootScope, AssetService, ImportService) {
      return {
        restrict:    'E',
        templateUrl: 'lm-video-upload/lm-video-upload.tpl.html',
        replace:     true,
        scope:       {
          ngModel:        '=',
          ngDisabled:     '=?',
          onUpload:       '&',
          error:          '=?'
        },
        link:        function (scope, element, attrs) {
          scope.src = scope.ngModel;
          scope._image_element_ = element;
          scope._input_ = element.find('input#video-file-input');
          scope._form_ = element.find('form#video-file-form');
          scope._progress_ = element.find('#video_uploader');
          scope._bar_ = scope._progress_.find('.determinate');

          scope.uploadTo = function (event) {
            if (scope.ngDisabled) return;

            $timeout(function () {
              scope._input_.trigger('click');
            });
          };

          var unwatch = scope.$watch('ngModel', function (newValue, oldValue) {
            if (newValue) {
              scope.src = newValue;
            }
          });

          $timeout(function () {
            scope._input_
              .on('change', function () {
                $timeout(function () {
                  scope.error = '';
                });
                if (!this.files || !this.files.length) {
                  $timeout(function () {
                    scope.error = 'Please, select file';
                  });
                  return;
                }

                var file = this.files[0];

                if (file.size > 104857600) {
                    $timeout(function () {
                        scope.error = 'File size exceed 100 MB. This file size is: ' + parseInt(file.size / 1024 / 1024, 10) + ' MB';
                    });
                  return;
                }

                ImportService.UploadToCloud(file, scope._progress_)
                    .then(function (response) {
                      scope._bar_.css({width: 0});
                      scope.ngModel = response.Location;
                      if (scope.onUpload) {
                        $timeout(function () {
                          scope.onUpload();
                        });
                      }
                    }, function (reason) {
                      scope._bar_.css({width: 0});
                      scope.error = reason.message || 'Error during upload';
                      $rootScope.debugInfo(reason);
                    });

                scope._form_[0].reset();
              });
          }, 200);

          scope.$on('$destroy', function () {
            unwatch();
          });
        }
      }
    }]);
